export default __webpack_public_path__ + "static/media/pen-active.e796d16c.svg";